var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.open
    ? _c(
        "div",
        {
          staticClass: "vks-data-table-modal",
          attrs: {
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": "vks-data-table-title",
          },
          on: {
            click: function ($event) {
              if ($event.target !== $event.currentTarget) return null
              return _vm.$emit("close")
            },
          },
        },
        [
          _c("div", { staticClass: "vks-data-table-panel" }, [
            _c("header", { staticClass: "vks-data-table-head" }, [
              _c("h2", { attrs: { id: "vks-data-table-title" } }, [
                _vm._v("Variant data table"),
              ]),
              _c(
                "button",
                {
                  staticClass: "vks-data-table-close",
                  attrs: { type: "button", "aria-label": "Close data table" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                },
                [_vm._v(" × ")]
              ),
            ]),
            _c(
              "div",
              { staticClass: "vks-data-table-body" },
              [
                _c("VariantSifterMappingBar", {
                  attrs: {
                    categories: _vm.mappingCategories,
                    "selected-category-ids": _vm.selectedCategoryIds,
                    "mapping-mode": _vm.mappingMode,
                    "workspace-filter-active": Boolean(
                      _vm.workspaceMappingFilter?.active
                    ),
                    "workspace-filter-row-count":
                      _vm.workspaceMappingFilter?.rowCount || 0,
                  },
                  on: {
                    "update:selectedCategoryIds":
                      _vm.onSelectedCategoryIdsUpdate,
                    "update:mappingMode": _vm.onMappingModeUpdate,
                    "update:workspaceFilterActive": function ($event) {
                      return _vm.$emit("update:workspaceFilterActive", $event)
                    },
                    "remove-category": function ($event) {
                      return _vm.$emit("remove-mapping-category", $event)
                    },
                  },
                }),
                _c("VariantSifterDataTableView", {
                  attrs: {
                    rows: _vm.tableView.rows,
                    "top-rows": _vm.tableView.topRows,
                    "table-format": _vm.tableView.tableFormat,
                    utils: _vm.utils,
                    "starred-variant-ids": _vm.starredVariantIds,
                    "show-star-column": true,
                    note: _vm.tableNote,
                    "empty-message":
                      "No variant rows match the current filters.",
                    "default-per-page": 10,
                  },
                  on: {
                    "toggle-star-variant": function ($event) {
                      return _vm.$emit("toggle-star-variant", $event)
                    },
                  },
                }),
              ],
              1
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }